import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 32px 24px;
  overflow: auto;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;
  width: 100%;
  gap: 24px;
  margin: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 26px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0;
`;

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  line-height: 1.6;
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LangBtnWrap = styled.div`
  & > div > div:last-child {
    border-radius: 12px !important;
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor} !important;
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground} !important;
    padding: 14px 16px !important;
  }
`;

export const InfoBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    opacity: 0.4;
  }

  &:focus {
    border-color: ${({ theme }) => theme.menu.selectedTextColor};
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 15px;
  font-family: inherit;
  outline: none;
  resize: none;
  height: 100px;
  transition: border-color 0.2s;

  &::placeholder {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    opacity: 0.4;
  }

  &:focus {
    border-color: ${({ theme }) => theme.menu.selectedTextColor};
  }
`;

export const DateInputBox = styled.div`
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  position: relative;
  min-height: 52px;
  display: flex;
  align-items: center;

  .react-date-picker {
    width: 100%;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
  .react-date-picker__wrapper {
    border: none;
    width: 100%;
    padding: 0;
  }
  .react-date-picker__inputGroup__input {
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
  .react-calendar {
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    border-radius: 10px;
  }
  .react-calendar__tile--active {
    background: ${({ theme }) => theme.menu.selectedTextColor};
  }
  .react-calendar__navigation button {
    color: ${({ theme }) => theme.menu.selectedTextColor};
  }
  .react-calendar__month-view__days__day {
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;

export const GenderRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`;

export const GenderCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 6px;
  border-radius: 12px;
  border: 1.5px solid
    ${({ $selected, theme }) =>
      $selected ? theme.menu.selectedTextColor : theme.sidebar.borderColor};
  background: ${({ $selected, theme }) =>
    $selected
      ? theme.menu.selectedTextColor.replace(/,\s*[\d.]+\)$/, ", 0.18)")
      : theme.menu.enterPhoneNumberBackground};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.menu.selectedTextColor};
  }
`;

export const GenderEmoji = styled.span`
  font-size: 20px;
  line-height: 1;
`;

export const GenderLabel = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${({ $selected, theme }) =>
    $selected ? theme.menu.selectedTextColor : theme.menu.secondaryTextColor};
  text-align: center;
  line-height: 1.3;
`;

export const ContinueBtn = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: none;
  background: ${({ disabled, theme }) =>
    disabled ? theme.sidebar.borderColor : theme.menu.selectedTextColor};
  color: ${({ disabled }) => (disabled ? "rgba(255,255,255,0.4)" : "#fff")};
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const ReadyScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px 0 8px;
  text-align: center;
`;

export const ReadyEmoji = styled.div`
  font-size: 56px;
  line-height: 1;
`;

export const ReadyTitle = styled.h2`
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 26px;
  font-weight: 700;
  margin: 0;
`;

export const ReadySubtitle = styled.p`
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
`;

export const ReadyBtn = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: none;
  background: ${({ theme }) => theme.menu.selectedTextColor};
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  margin-top: 8px;
  transition: opacity 0.2s;
  &:hover { opacity: 0.9; }
`;

export const ReadyBtnOutline = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: 1.5px solid ${({ theme }) => theme.sidebar.borderColor};
  background: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.2s;
  &:hover { border-color: ${({ theme }) => theme.menu.selectedTextColor}; }
`;
